import * as React from 'react';
import './CheckBoxGR.scss';
import { ExtraDisclaimers } from 'ouisys-component-library';
import { useRootContext } from '../../providers/RootContext';
import { legals } from '../../localization';

const CheckBoxGR = ({ checked, onCheckedChange, onClicked }) => {
  const { locale } = useRootContext();
  return (
    <div className="terms-component">
      <div className={`terms service-${process.env.service} compliant`}>
        <label
          htmlFor="agree"
          onClick={() => {
            onClicked();
          }}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={(ev) => onCheckedChange(ev.target.checked)}
            name="agree"
            id="agree"
          />
          <ExtraDisclaimers className="disclaimer" locale={locale} legals={legals} />
        </label>
      </div>
    </div>
  );
};
export default CheckBoxGR;
